import React from 'react';
import { DialogTitle } from '@material-ui/core';
import Button from './../controls/Button';
import { withRouter } from 'react-router-dom';
import { Dialog, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';

class UnsavedDialog extends React.Component {
    handleDiscardChanges = () => {
        this.props.handleCloseUnsavedDialog();
        this.props.onDiscardChanges(this.props.parent);
    };

    handleSaveAndRedirect = () => {
        this.props.onSaveAndRedirect(this.props.parent, this.props.handleCloseUnsavedDialog);
    };

    render() {
        return (
            <Dialog open={this.props.openUnsavedDialog}>
                <DialogTitle>Wait!</DialogTitle>
                <DialogContent>
                    <DialogContentText id="unsavedQuestion">Save or discard the unsaved changes?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleDiscardChanges} color="primary">
                        Discard
                    </Button>
                    <Button onClick={this.handleSaveAndRedirect} color="primary">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
export default withRouter(UnsavedDialog);
